﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { IWordListField, IWordListProperty } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.WordListField, eOutputFieldType.wordList)
export class WordListField extends OutputField implements IWordListField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }
    public deleted: boolean;
    public value: {}[];
    public properties: IWordListProperty[];
}
